import { fetch } from "src/features/visitorTournament/imports/api";
import { getProxycadorHost } from "src/features/visitorTournament/imports/environment";
import { Tournament } from "src/features/visitorTournament/imports/types";

export const fetchVisitorTournament = (name: string): Promise<Tournament> =>
  fetch(
    `${getProxycadorHost()}/visitors/tournament/api/public/v1/tournaments/lwc/${name}`
  ).then((resp) => resp.json());
